import exactShape from 'prop-types-exact';
import ImmutablePropTypes from 'react-immutable-proptypes';
import createCustomReactPropType from '@dbh/create-custom-react-prop-type';
import isStringBlank from '@dbh/is-string-blank';
import 'lodash/has';
import 'prop-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import 'lodash/isBoolean';
import invariant from 'invariant';
import 'lodash/isFunction';
import _noop from 'lodash/noop';
import 'check-prop-types';
import _isString from 'lodash/isString';
import _isEqual from 'lodash/isEqual';
import _uniqWith from 'lodash/uniqWith';
import _isPlainObject from 'lodash/isPlainObject';
import { List } from 'immutable';
import '@dbh/environment';
import 'email-validator';
import 'lodash/isNaN';
import 'common-tags';
import 'lodash/isFinite';

const mapContainsExactImmutablePropType=a=>// eslint-disable-next-line @dbh/react/prefer-exact-prop-types
ImmutablePropTypes.mapContains(exactShape(a));var mapContainsExactImmutablePropType$1 = mapContainsExactImmutablePropType;

const nonEmptyStringArrayPropType=createCustomReactPropType((a,b,c)=>{const d=a[b];if(!Array.isArray(d))return new Error(c+" invalid prop `"+b+"`:\n"+("Expected an array, got: "+d));const e=d.length;if(!e)return new Error(c+" invalid prop `"+b+"`:\n"+("Expected an array of strings with at least one element. got: "+d));const f=d.every(a=>"string"==typeof a&&!isStringBlank(a));return f?null:new Error(c+" invalid prop `"+b+"`:\n"+("Expected an array containing only strings. Got: "+d))});var nonEmptyStringArrayPropType$1 = nonEmptyStringArrayPropType;

/**
 * Creates a `React` `prop-type` validator checks that only one of the
 * given prop names is passed.
 * @param {string} componentName `React` component name.
 * @param {string[]} paramPropNames `React` props keys.
 * @param {Object?} options .
 * @param {boolean?} options.onePropMustBePassed If `true`, at least one of the
 * props must be passed, or this validator returns an error.
 * @return {Function} Validates props.
 */const createOnlyOnePropPassedPropType=withConformsTo("createOnlyOnePropPassedPropType",[],()=>/**
     * Curried function.
     *
     * @param {Object} props `React` props.
     * @return {Error|null} Returns nothing if:
     * A) Only one prop is passed.
     * B) None of the props is passed.
     * Or an error if:
     * A) More than one of `paramPropNames` props are passed.
     */()=>null);var createOnlyOnePropPassedPropType$1 = createOnlyOnePropPassedPropType;

/**
 * Creates a `React` `prop-type` validator which checks if `paramPropNames` props
 * are present when `props[paramPropNameIfPassed]` is passed.
 *
 * @param {string} componentName `React` component name.
 * @param {string[]} paramPropNames `React` props keys.
 * @param {string} paramPropNameIfPassed `React` prop key.
 * @return {Function} Validates props.
 */const createIfOnePassedOthersRequiredPropType=()=>(()=>null);var createIfOnePassedOthersRequiredPropType$1 = createIfOnePassedOthersRequiredPropType;

/**
 * Creates a `React` `prop-type` validator which checks that `paramPropNames`
 * props are present when `props[paramPropNameIfPassed]` is not passed or passed
 * and not truthy. @TODO `jest` test.
 * @param {string} componentName `React` component name.
 * @param {string[]} paramPropNames `React` props keys.
 * @param {string} paramPropNameIfPassed `React` prop key.
 * @return {Function} Validates props.
 */const createIfOneNotPassedAndTruthyOthersRequiredPropType=()=>(()=>null);var createIfOneNotPassedAndTruthyOthersRequiredPropType$1 = createIfOneNotPassedAndTruthyOthersRequiredPropType;

/**
 * Call all the React `prop-types` validators and return error if just one
 * returns error. So they all must pass.
 * @param {Function[]} types A collection of `React` `prop-types`.
 * @return {Error?} Validations compound result.
 */const allPropTypesMustPass=_noop;var allPropTypesMustPass$1 = allPropTypesMustPass;

/*
 *
 * `createNonEmptyStringPropType`: `@dbh/validation`.
 *
 */ /**
 * Creates a `React` `prop-type` validator which checks that
 * `props[paramPropName]` is a not empty `String`, optionally required.
 * @param {string} componentName `React` component name.
 * @param {string} paramPropName A `React` prop key.
 * @param {boolean?} isRequired Should `props[paramPropName]` be required.
 * @return {Function} Validates props.
 */const createNonEmptyStringPropType=()=>/**
   * @param {Object} props `React` props.
   * @return {null} If:
   * - `isRequired=false` and `props[paramPropName]=undefined`.
   * - `props[paramPropName]` is not empty `String`.
   * @return {Error} If:
   * - `props[paramPropName]` is not a `String`.
   * - `props[paramPropName]` is empty `String` or contains only spaces.
   */()=>null;var createNonEmptyStringPropType$1 = createNonEmptyStringPropType;

/**
 * React `prop-types` validator, checks that the given list contains unique
 * values. The parameters it takes are the standard parameter every React
 * `prop-types` validator is passed by React.
 * @see {@link https://github.com/facebook/prop-types}.
 * @return {Error?} Returns an error if `source` does not contain unique values.
 */const listOfUniqueValuesImmutablePropType=createCustomReactPropType((a,b,c,d/* `propLocation` */,e)=>{const f=a[b];if(!List.isList(f))// We cannot use `validateImmutableList` because it throws, we want to
// return the error here instead.
return new Error("Invalid type of prop `"+e+"`, supplied\n        to `"+c+"`, expected to be `Immutable.List`");const g=f.toJS(),h=g.filter(_isPlainObject).length;let i=!0;return i=h?_uniqWith(g,_isEqual).length===g.length:g.length===new Set(g).size,i?null:new Error("Invalid prop: `"+b+"` supplied to `"+c+"`, expected it "+("to have unique values. Given: "+f))});var listOfUniqueValuesImmutablePropType$1 = listOfUniqueValuesImmutablePropType;

const createHtmlStringsPropType=(a,b)=>_noop,createHtmlStringPropType=(a,b)=>(invariant(_isString(b),"(makePropTypeHtmlString) Expected `paramPropName` to be a String."),createHtmlStringsPropType());/**
 * Performs some basic operations to understand if the value is possibly valid
 * `HTML` or if it contains values that are clearly not allowed in `HTML`.
 * @param {string?} paramString A value to check.
 * @return {boolean} The answer to "is this `paramString` possibly `HTML`?".
 */ /**
 * Creates a `React` `prop-type` validator which checks that `paramPropNameOrNames`
 * props are `html` strings.
 *
 * @param {string} componentName `React` component name.
 * @param {string|string[]} paramPropNameOrNames One or more `React` props keys.
 * @return {Function} Validates props.
 */ /**
 * Description: @see `makePropTypeHtmlStrings`.
 * @param {string} componentName `React` component name.
 * @param {string} paramPropName A `React` prop key.
 * @return {Function} @see `makePropTypeHtmlStrings`.
 */var createHtmlStringPropType$1 = createHtmlStringPropType;

const jsonStringPropType=createCustomReactPropType((a,b,c)=>{const d=a[b];try{JSON.parse(d);}catch(a){return new Error(c+" invalid prop `"+b+"`:\n"+("expected a valid JSON string, got: "+d))}return null});var jsonStringPropType$1 = jsonStringPropType;

/**
 * React `prop-types` validator, checks that the given list contains unique
 * values. The parameters it takes are the standard parameter every React
 * `prop-types` validator is passed by React.
 * @see {@link https://github.com/facebook/prop-types}.
 * @return {Error?} Returns an error if `source` does not contain unique values.
 */const listOfUniqueValuesPropType=createCustomReactPropType((a,b,c)=>{const d=a[b];if(!Array.isArray(d))return new Error("Invalid type of prop `"+b+"`, supplied to `"+c+"`, expected it to be an Array");const e=d.filter(_isPlainObject).length;let f=!0;return f=e?_uniqWith(d,_isEqual).length===d.length:d.length===new Set(d).size,f?null:new Error("Invalid prop: `"+b+"` supplied to `"+c+"`, expected it "+("to have unique values. Given: "+d))});var listOfUniqueValuesPropType$1 = listOfUniqueValuesPropType;

const absoluteUrlPropType=createCustomReactPropType((a,b,c)=>{const d=a[b];try{// eslint-disable-next-line no-unused-vars
new URL(d);}catch(a){return new Error(c+" invalid prop `"+b+"`:\n"+("expected a valid absolute URL, got: "+d))}return null});var absoluteUrlPropType$1 = absoluteUrlPropType;

/**
 * Creates a `React` `prop-type` validator which checks that:
 * A) ONLY one of `paramPropNames` props is present.
 * B) AT LEAST one of `paramPropNames` is present.
 * @param {string} componentName `React` component name.
 * @param {string[]} paramPropNames `React` props keys.
 * @param {boolean?} onlyOneOfThePropsIsAllowed Should it check "ONLY" one or
 * "AT LEAST" one of `paramPropNames` props.
 * @return {Function} Validates props.
 */const createRequireOneOfPropType=function(a,b,c){/**
   * Curried function.
   *
   * @param {Object} props `React` props.
   * @return {Error|null} Returns nothing if:
   * `onlyOneOfThePropsIsAllowed=true` ONLY one of `paramPropNames` props is passed.
   * `onlyOneOfThePropsIsAllowed=false` AT LEAST one of `paramPropNames` props is passed.
   * Or an Err if:
   * No prop of `paramPropNames` is passed.
   * `onlyOneOfThePropsIsAllowed=true` ONLY more than one of `paramPropNames` props are passed.
   */return ()=>null};/**
 * Creates a `React` `prop-type` validator which checks that AT LEAST
 * one of `paramPropNames` props is present.
 * @see `makePropTypeRequireOneOf`.
 * @param {string} componentName `React` component name.
 * @param {string[]} paramPropNames `React` props keys.
 * @return {Function} @see `makePropTypeRequireOneOf`.
 */const createPropTypeRequireAtLeastOneOf=(a,b)=>createRequireOneOfPropType();/**
 * Creates a `React` `prop-type` validator which checks that ONLY
 * one of `paramPropNames` props is present.
 * @see `makePropTypeRequireOneOf`.
 * @param {string} componentName `React` component name.
 * @param {string[]} paramPropNames `React` props keys.
 * @return {Function} @see `makePropTypeRequireOneOf`.
 */const createPropTypeRequireOnlyOneOf=(a,b)=>createRequireOneOfPropType();

const htmlTagPropType=_noop;const targetPropType=_noop;const verticalAlignPropType=_noop;

const finiteNumberPropType=_noop;var finiteNumberPropType$1 = finiteNumberPropType;

// when `builtins: true` (the default, we want to keep it like that) throws the
// following error: "Error: Couldn't find intersection".
const createPropTypeFiniteNumberBetween=()=>_noop;var createPropTypeFiniteNumberBetween$1 = createPropTypeFiniteNumberBetween;

const createPropTypeFiniteNumberFrom=()=>_noop;var createPropTypeFiniteNumberFrom$1 = createPropTypeFiniteNumberFrom;

// when `builtins: true` (the default, we want to keep it like that) throws the
// following error: "Error: Couldn't find intersection".
const createPropTypeFiniteNumberStringBetween=()=>_noop;var createPropTypeFiniteNumberStringBetween$1 = createPropTypeFiniteNumberStringBetween;

const listOfNumbersImmutablePropType=_noop;var listOfNumbersImmutablePropType$1 = listOfNumbersImmutablePropType;

const numberThatIsNotNegativeAndNotZeroPropType=_noop;var numberThatIsNotNegativeAndNotZeroPropType$1 = numberThatIsNotNegativeAndNotZeroPropType;

const numberThatIsNotNegativeButCanBeZeroPropType=_noop;var numberThatIsNotNegativeButCanBeZeroPropType$1 = numberThatIsNotNegativeButCanBeZeroPropType;

const numberStringThatIsNotNegativeAndNotZeroPropType=_noop;var numberStringThatIsNotNegativeAndNotZeroPropType$1 = numberStringThatIsNotNegativeAndNotZeroPropType;

/**
 * @typedef {Immutable.Map<{
 * id: number,
 * idHotel: number?,
 * url: string,
 * isDefault: boolean?
 * }>} Image
 */const imageImmutablePropType=_noop;/**
 * @typedef {Immutable.List<Image>} ImagesList
 */const imagesListImmutablePropType=_noop;const imageWidthPropType=_noop;const imageHeightPropType=_noop;const imageQualityPropType=_noop;const imageMapImmutablePropType=_noop;

const refPropType=_noop;const styledCssPropType=_noop;const reactChildrenPropType=_noop;

const nonBlankStringPropType=createCustomReactPropType((a,b,c)=>{const d=a[b];return "string"!=typeof d||isStringBlank(d)?new Error(c+" invalid prop `"+b+"`:\n"+("expected a non blank string, got: "+d)):null});var nonBlankStringPropType$1 = nonBlankStringPropType;

const getError=(a,b,c)=>new Error(c+" invalid prop `"+b+"`:\nexpected a string containing a valid regular expression, also not "+("starting or ending with a slash. Given: "+a)),stringContainingRegexPropType=createCustomReactPropType((a,b,c)=>{const d=a[b];let e=!0;if("string"!=typeof d||isStringBlank(d))return getError(d,b,c);if(d.startsWith("/")||d.endsWith("/"))return getError(d,b,c);try{RegExp(d);}catch(a){e=!1;}return e?null:getError(d,b,c)});var stringContainingRegexPropType$1 = stringContainingRegexPropType;

const booleanStringPropType=_noop;var booleanStringPropType$1 = booleanStringPropType;

const emailPropType=_noop;

export { absoluteUrlPropType$1 as absoluteUrlPropType, allPropTypesMustPass$1 as allPropTypesMustPass, booleanStringPropType$1 as booleanStringPropType, createHtmlStringPropType$1 as createHtmlStringPropType, createIfOneNotPassedAndTruthyOthersRequiredPropType$1 as createIfOneNotPassedAndTruthyOthersRequiredPropType, createIfOnePassedOthersRequiredPropType$1 as createIfOnePassedOthersRequiredPropType, createNonEmptyStringPropType$1 as createNonEmptyStringPropType, createOnlyOnePropPassedPropType$1 as createOnlyOnePropPassedPropType, createPropTypeFiniteNumberBetween$1 as createPropTypeFiniteNumberBetween, createPropTypeFiniteNumberFrom$1 as createPropTypeFiniteNumberFrom, createPropTypeFiniteNumberStringBetween$1 as createPropTypeFiniteNumberStringBetween, createPropTypeRequireAtLeastOneOf, createPropTypeRequireOnlyOneOf, emailPropType, finiteNumberPropType$1 as finiteNumberPropType, htmlTagPropType, imageHeightPropType, imageImmutablePropType, imageMapImmutablePropType, imageQualityPropType, imageWidthPropType, imagesListImmutablePropType, jsonStringPropType$1 as jsonStringPropType, listOfNumbersImmutablePropType$1 as listOfNumbersImmutablePropType, listOfUniqueValuesImmutablePropType$1 as listOfUniqueValuesImmutablePropType, listOfUniqueValuesPropType$1 as listOfUniqueValuesPropType, mapContainsExactImmutablePropType$1 as mapContainsExactImmutablePropType, nonBlankStringPropType$1 as nonBlankStringPropType, nonEmptyStringArrayPropType$1 as nonEmptyStringArrayPropType, numberStringThatIsNotNegativeAndNotZeroPropType$1 as numberStringThatIsNotNegativeAndNotZeroPropType, numberThatIsNotNegativeAndNotZeroPropType$1 as numberThatIsNotNegativeAndNotZeroPropType, numberThatIsNotNegativeButCanBeZeroPropType$1 as numberThatIsNotNegativeButCanBeZeroPropType, reactChildrenPropType, refPropType, stringContainingRegexPropType$1 as stringContainingRegexPropType, styledCssPropType, targetPropType, verticalAlignPropType };
